export enum Actions {
  Share,
  Mute,
  UnMute,
  FullScreen,
  ExitFullScreen,
  HD,
  SD,
}
